import { forwardRef, useRef } from 'react';

const mergeRefs = (ref, innerRef) => (node) => {
  innerRef.current = node;
  if (typeof ref === 'function') ref(node);
  else if (ref) ref.current = node;
};

const blockTyping = (e) => {
  const allowed = ['Tab', 'Escape', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
  if (!allowed.includes(e.key)) e.preventDefault();
};

const DatePicker = forwardRef(
  (
    {
      label,
      id,
      className = '',
      inputClassName = '',
      required,
      compact = false,
      min,
      max,
      value,
      onChange,
      ...props
    },
    ref
  ) => {
    const innerRef = useRef(null);

    const openPicker = () => {
      const el = innerRef.current;
      if (!el || el.disabled) return;
      if (typeof el.showPicker === 'function') {
        try {
          el.showPicker();
        } catch {
          el.focus();
        }
      } else {
        el.focus();
      }
    };

    const fieldClass = compact
      ? `rounded-lg border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-950 px-3 py-2 text-sm ${inputClassName}`
      : `w-full rounded-lg border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-950 px-3 py-2 text-sm ${inputClassName}`;

    return (
      <div className={`${compact ? '' : 'w-full'} ${className}`}>
        {label && (
          <label htmlFor={id} className="mb-1 block text-sm text-zinc-600 dark:text-zinc-400">
            {label}
            {required ? ' *' : ''}
          </label>
        )}
        <div className="relative cursor-pointer" onClick={openPicker}>
          <input
            ref={mergeRefs(ref, innerRef)}
            id={id}
            type="date"
            min={min}
            max={max}
            required={required}
            value={value}
            onChange={onChange}
            onKeyDown={blockTyping}
            className={`date-picker-input ${fieldClass} cursor-pointer pr-10`}
            {...props}
          />
          <span
            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-base text-zinc-600 dark:text-zinc-400"
            aria-hidden
          >
            📅
          </span>
        </div>
      </div>
    );
  }
);

DatePicker.displayName = 'DatePicker';

export default DatePicker;
